export enum UserConnectionStatus {
    PENDING = "PENDING",
    CONNECTED = "CONNECTED",
    NOT_CONNECTED = "NOT_CONNECTED",
}